export default function Longclick() {

  let defaults = {
      target: document,
      mouseDown: function() { console.log("Mousedown!"); },
  }

  this.options = { }

  // Create options by extending defaults with the passed in arugments
  if (arguments[0] && typeof arguments[0] === "object") {
      this.options = extendDefaults(defaults, arguments[0]);
  }

  // Private Methods
  function extendDefaults(source, properties) {
      let property;
      for (property in properties) {
          if (properties.hasOwnProperty(property)) {
              source[property] = properties[property];
          }
      }
      return source;
  }
  this.init(); 
}

// Private Functions
Longclick.prototype.init = function() {
  let _this = this;

  //detect mousedown
  _this.detectMouseDown();

  //detect mouseup
  _this.detectMouseUp();
}

Longclick.prototype.detectMouseDown = function() {
    var target = this.options.target;
    var _this = this;
    console.log(target);
    target.addEventListener('mousedown', function() {
        if(_this.options.mousedownID==-1) {
            //Prevent multimple loops!
            _this.options.mousedownID = setInterval(_this.options.mouseDown, 100);
        }  
    });
}

Longclick.prototype.detectMouseUp = function() {
    var target = this.options.target;
    var _this = this;

    var onMouseUpOrOut = function() {
        if(_this.options.mousedownID!=-1) {  //Only stop if exists
            clearInterval(_this.options.mousedownID);
            _this.options.mousedownID=-1;
        }
    }

    target.addEventListener('mouseup', onMouseUpOrOut);
    target.addEventListener('mouseout', onMouseUpOrOut);
}